import { useEffect, useState } from "react";
import {
  useNavigate,
  useParams,
} from "react-router-dom";

import { useOfferings } from "../hooks/useOfferings";

import {
  getCategoriesApi
} from "../../../api/categories/categories.api";

import OfferingForm from "../components/OfferingForm";


const OfferingEditPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    offering,
    fetchOffering,
    editOffering,
    detailsLoading,
    loading,
  } = useOfferings();


  const [categories, setCategories] =
    useState([]);

  const [categoriesLoading, setCategoriesLoading] =
    useState(true);

  const [pageError, setPageError] =
    useState(null);


  useEffect(() => {
    if (!id) {
      return;
    }

    const loadData = async () => {
      try {
        setPageError(null);

        await fetchOffering(id);

        const response = await getCategoriesApi();

        setCategories(
          response?.data?.data ||
          response?.data ||
          []
        );
      } catch (err) {
        console.error(
          "Failed to load edit page:",
          err
        );

        setPageError(
          err?.response?.data?.message ||
          err?.message ||
          "Failed to load offering"
        );
      } finally {
        setCategoriesLoading(false);
      }
    };

    loadData();
  }, [id, fetchOffering]);


  const handleSubmit = async (formData) => {
    try {
      await editOffering(
        id,
        formData
      );

      navigate(
        `/offerings/${id}`
      );
    } catch (err) {
      console.error(
        "Update offering failed:",
        err
      );
    }
  };


  if (detailsLoading) {
    return (
      <div className="loading">
        Loading offering...
      </div>
    );
  }


  if (pageError) {
    return (
      <div className="error-message">
        {pageError}
      </div>
    );
  }


  if (!offering) {
    return (
      <div className="empty-state">
        Offering not found.
      </div>
    );
  }


  return (
    <div className="offering-edit-page">

      <div className="page-header">

        <div>
          <h1>
            Edit Offering
          </h1>

          <p>
            Update {offering.name}
          </p>
        </div>

      </div>


      <OfferingForm
        initialData={offering}
        categories={categories}
        categoriesLoading={
          categoriesLoading
        }
        loading={loading}
        onSubmit={handleSubmit}
        submitLabel="Update Offering"
      />

    </div>
  );
};


export default OfferingEditPage;